import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import moment from 'moment/moment'
import {
  calculateHoursBetween,
  convertIntToState_ws,
  formatTime,
  rearrangeByPinned
} from '../../../utils/openForWork.utils'
import { CloseIcon } from '../../openforwork/closeIcon.component'
import WorkshiftDetails_Employer from './workshiftDetails_employer.component'
import PushPinIcon from '@mui/icons-material/PushPin'

const styles = (theme) => ({
  tablecell: {
    fontSize: '12px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    verticalAlign: 'top',
    wordWrap: 'break-word'
  },
  tablecell2: {
    fontSize: '12px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    border: 'none',
    verticalAlign: 'top'
  },
  tablecell3: {
    fontSize: '12px',
    padding: theme.spacing(1),
    borderBottom: '1px solid lightgrey',
    verticalAlign: 'top'
  },
  text: {
    width: '200px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal'
  },
  previewLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#808080'
  },
  previewValue: {
    fontWeight: 500
  }
})

const WorkshiftRow = ({
  shiftData,
  classes,
  getWorkshiftbyId,
  deleteWorkshift,
  showDeleteDialog,
  cancelDialog,
  removeWorkshift,
  deleteWorkshiftSuccess,
  emailSelectionList,
  confirmBillableHour,
  pinWorkshift,
  showWorkshiftFormDialog
}) => {
  const [expand, setExpand] = React.useState(false)
  const [selectedWorkshift, setSelectedWorkshift] = React.useState(null)
  const [isConfirmActualHours, setIsConfirmActualHours] = React.useState(false)
  const [isRejectActualHours, setIsRejectActualHours] = React.useState(false)

  const handleExpandClick = () => {
    setExpand((prevExpand) => !prevExpand)
  }

  const pendingAcceptance = shiftData.workshifts.filter(
    (el) => el.workshift_status_entrepreneur === 0
  ).length

  const renderStatus = (item = {}) =>
    item?.workshift_status_entrepreneur === 1
      ? convertIntToState_ws(5)
      : convertIntToState_ws(item?.workshift_status_entrepreneur)

  React.useEffect(() => {
    if (deleteWorkshiftSuccess) {
      setSelectedWorkshift(null)
    }
  }, [deleteWorkshiftSuccess])

  const workshiftRows = rearrangeByPinned(
    shiftData.workshifts,
    'pinned_workshift'
  )

  return (
    <Translation>
      {(t) => {
        return (
          <>
            <TableRow
              style={{ cursor: 'pointer' }}
              onClick={() => {
                handleExpandClick()
              }}
            >
              <TableCell className={classes.tablecell}>
                {shiftData.name}
              </TableCell>
              <TableCell className={classes.tablecell}>
                {shiftData.offered_to}
              </TableCell>
              <TableCell className={classes.tablecell}>
                {shiftData.workshifts.length === 1
                  ? shiftData.workshifts.length +
                    ' ' +
                    t('employer.workshifts.note2')
                  : shiftData.workshifts.length +
                    ' ' +
                    t('employer.workshifts.note3')}
                {pendingAcceptance > 0 && (
                  <span>
                    {' '}
                    ({pendingAcceptance + ' ' + t('employer.workshifts.note4')})
                  </span>
                )}
              </TableCell>
              <TableCell className={classes.tablecell}>
                <div className="pull-right">
                  <IconButton aria-label="expand row" size="small">
                    {expand ? (
                      <KeyboardArrowUp fontSize="large" />
                    ) : (
                      <KeyboardArrowDown fontSize="large" />
                    )}
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
            {expand ? (
              <>
                <TableRow>
                  <TableCell className={classes.tablecell} colSpan={4}>
                    <div>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell className={classes.tablecell}>
                              <b>{t('employer.workshifts.col1')}</b>
                            </TableCell>
                            <TableCell className={classes.tablecell}>
                              <b>{t('employer.workshifts.col3')}</b>
                            </TableCell>
                            <TableCell className={classes.tablecell}>
                              <b>{t('employer.workshifts.col4')}</b>
                            </TableCell>
                            <TableCell className={classes.tablecell}>
                              <b>{t('employer.workshifts.col8')}</b>
                            </TableCell>
                            <TableCell
                              className={classes.tablecell}
                            ></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {workshiftRows.map((row) => (
                            <TableRow key={row.workshift_itemid}>
                              <TableCell
                                className={classes.tablecell}
                                style={{ maxWidth: '300px' }}
                              >
                                <u
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    setSelectedWorkshift(row)
                                  }}
                                >
                                  {row.task_description}
                                </u>
                              </TableCell>
                              <TableCell className={classes.tablecell}>
                                {moment(row?.workshift_date).format(
                                  'DD.MM.YYYY'
                                )}
                              </TableCell>
                              <TableCell className={classes.tablecell}>
                                {formatTime(
                                  row?.workshift_status === 3
                                    ? row?.actualworkshift_starttime
                                    : row?.workshift_start_time
                                ) +
                                  ' - ' +
                                  formatTime(
                                    row?.workshift_status === 3
                                      ? row?.actualworkshift_endtime
                                      : row?.workshift_endtime
                                  )}
                                {row?.workshift_status_entrepreneur === 2 &&
                                  (row?.actualworkshift_starttime !==
                                    row?.workshift_start_time ||
                                    row?.actualworkshift_endtime !==
                                      row?.workshift_endtime) && (
                                    <>
                                      <br />
                                      <span style={{ color: '#F67131' }}>
                                        (
                                        {formatTime(
                                          row?.actualworkshift_starttime
                                        ) +
                                          ' - ' +
                                          formatTime(
                                            row?.actualworkshift_endtime
                                          )}
                                        )
                                      </span>
                                    </>
                                  )}
                              </TableCell>
                              <TableCell className={classes.tablecell}>
                                {renderStatus(row)}
                              </TableCell>
                              <TableCell className={classes.tablecell}>
                                <div className="pull-right">
                                  <IconButton
                                    aria-label="expand row"
                                    size="small"
                                    style={
                                      row.pinned_workshift
                                        ? { color: '#F67131' }
                                        : {}
                                    }
                                    onClick={() => {
                                      pinWorkshift(row.workshift_itemid)
                                    }}
                                  >
                                    <PushPinIcon />
                                  </IconButton>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  </TableCell>
                </TableRow>
                <Dialog
                  open={selectedWorkshift !== null}
                  onClose={() => setSelectedWorkshift(null)}
                  fullWidth
                  maxWidth="md"
                >
                  <CloseIcon
                    fontSize="large"
                    onClick={() => setSelectedWorkshift(null)}
                  />
                  <DialogTitle id="alert-dialog-title">
                    <div
                      style={{
                        textAlign: 'center',
                        color: '#000000',
                        fontSize: '15px'
                      }}
                    >
                      {t('employer.workshifts.dialogTitle2')}
                    </div>
                  </DialogTitle>
                  <DialogContent>
                    <div>
                      <WorkshiftDetails_Employer
                        classes={classes}
                        t={t}
                        task_description={selectedWorkshift?.task_description}
                        entrepreneur={
                          selectedWorkshift?.firstname +
                          ' ' +
                          selectedWorkshift?.lastname
                        }
                        email={selectedWorkshift?.offershift_to}
                        location={selectedWorkshift?.location}
                        workshift_date={moment(
                          selectedWorkshift?.workshift_date
                        ).format('DD.MM.YYYY')}
                        working_hours={
                          formatTime(selectedWorkshift?.workshift_start_time) +
                          ' - ' +
                          formatTime(selectedWorkshift?.workshift_endtime)
                        }
                        actualworkshift_starttime={formatTime(
                          selectedWorkshift?.actualworkshift_starttime
                        )}
                        actualworkshift_endtime={formatTime(
                          selectedWorkshift?.actualworkshift_endtime
                        )}
                        workshift_additional_comments={
                          selectedWorkshift?.workshift_additional_comments ===
                          'As scheduled'
                            ? ''
                            : selectedWorkshift?.workshift_additional_comments
                        }
                        actual_hours={
                          formatTime(
                            selectedWorkshift?.actualworkshift_starttime
                          ) +
                          ' - ' +
                          formatTime(selectedWorkshift?.actualworkshift_endtime)
                        }
                        time_spent={calculateHoursBetween(
                          selectedWorkshift?.actualworkshift_starttime,
                          selectedWorkshift?.actualworkshift_endtime
                        )}
                        workshift_lastdate={moment(
                          selectedWorkshift?.workshift_lastdate
                        ).format('DD.MM.YYYY')}
                        status={renderStatus(selectedWorkshift)}
                        additional_info={selectedWorkshift?.additional_info}
                        status_entrepreneur={
                          selectedWorkshift?.workshift_status_entrepreneur
                        }
                        status_employer={selectedWorkshift?.workshift_status}
                        deleteWorkshift={deleteWorkshift}
                        workshift_id={selectedWorkshift?.workshift_id}
                        workshift_itemid={selectedWorkshift?.workshift_itemid}
                        getWorkshiftbyId={getWorkshiftbyId}
                        setSelectedWorkshift={setSelectedWorkshift}
                        emailSelectionList={emailSelectionList}
                        entrepreneurs_rating={
                          selectedWorkshift?.entrepreneurs_rating
                        }
                        confirmBillableHour={confirmBillableHour}
                        isConfirmActualHours={isConfirmActualHours}
                        setIsConfirmActualHours={setIsConfirmActualHours}
                        isRejectActualHours={isRejectActualHours}
                        setIsRejectActualHours={setIsRejectActualHours}
                        showWorkshiftFormDialog={showWorkshiftFormDialog}
                        workshift_remarks={
                          selectedWorkshift?.workshift_remarks !== null &&
                          selectedWorkshift?.workshift_remarks !== undefined
                            ? JSON.parse(selectedWorkshift?.workshift_remarks)
                            : null
                        }
                      />
                    </div>
                  </DialogContent>
                </Dialog>
                <Dialog
                  open={showDeleteDialog}
                  onClose={cancelDialog}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  BackdropProps={{
                    classes: {
                      root: classes.dialog
                    }
                  }}
                >
                  <DialogTitle id="alert-dialog-title">
                    <span style={{ fontSize: '20px' }}>
                      {t('employer.workshifts.dialogTitle1')}
                    </span>
                  </DialogTitle>
                  <DialogActions>
                    <div className="pull-right">
                      <Button
                        variant="outlined"
                        className={classes.dialogButton}
                        onClick={cancelDialog}
                      >
                        {t('employer.workshifts.btn2')}
                      </Button>
                      <Button
                        variant="contained"
                        className={classes.dialogButton}
                        onClick={() => {
                          removeWorkshift(
                            selectedWorkshift?.workshift_id,
                            selectedWorkshift?.workshift_itemid
                          )
                        }}
                      >
                        {t('employer.workshifts.btn5')}
                      </Button>
                    </div>
                  </DialogActions>
                </Dialog>
              </>
            ) : null}
          </>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(WorkshiftRow)
